<vg-player (onPlayerReady)="onPlayerReady($event)" class="player__vg vg">
  <vg-overlay-play vgFor="singleVideo"></vg-overlay-play>

  <video
    #media
    class="video"
    [vgMedia]="$any(media)"
    [src]="videoUrl"
    id="singleVideo"
    preload="auto"
    autoplay
    crossorigin
  ></video>
</vg-player>
